import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  apiGetLocalisation,
  apiSaveLocalisation,
  apiUpdateLocalisation,
  apiDecodeLatLng,
} from "../../../api/ApiLocalisation";
import { useTranslation } from "react-i18next";

const initialState = {
  nom: "",
  lat: "",
  lng: "",
  adresse: "",
  pays: "",
};

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;
  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [errorGPS, setErrorGPS] = useState("");

  const recupData = async () => {
    const res = await apiGetLocalisation(ReduxInstance._id, id);
    setState(res.data);
  };

  const submitData = async () => {
    if (id) {
      await apiUpdateLocalisation(id, state);
      handleRecupDatas();
    } else {
      await apiSaveLocalisation(ReduxInstance._id, state);
      handleRecupDatas();
    }
    handleClose();
  };

  const preremplirGPS = async (e) => {
    e.preventDefault();
    setErrorGPS("");
    if (state.adresse) {
      const res = await apiDecodeLatLng(state.adresse);

      if (res.data && res.data.features[0]) {
        setState({
          ...state,
          lng: res.data.features[0].geometry.coordinates[0],
          lat: res.data.features[0].geometry.coordinates[1],
        });
        setErrorGPS(
          "Coordonnées retournées : " + res.data.features[0].properties.label
        );
      } else {
        setErrorGPS("Impossible de trouver cette adresse");
      }
    }
  };

  useEffect(() => {
    setErrorGPS("");
    if (id) recupData();
    else setState(initialState);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t(
                "admin.PageAdminLocalisations.modalCreateEditTitre2"
              )
            : t(
                "admin.PageAdminLocalisations.modalCreateEditTitre1"
              )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            placeholder={t("commun.form.placeholder.placeholder1")}
            value={state.nom}
            onChange={(e) =>
              setState({ ...state, [e.target.name]: e.target.value })
            }
          />
          <label className="mt-2">{t("commun.form.label.intitule8")}</label>
          <Form.Control
            type="text"
            name="adresse"
            placeholder={t("commun.form.placeholder.placeholder2")}
            value={state.adresse}
            onChange={(e) => (
              setErrorGPS(""),
              setState({ ...state, [e.target.name]: e.target.value })
            )}
          />
          <label className="mt-2">{t("commun.form.label.intitule9")}</label>
          <Form.Control
            type="text"
            name="pays"
            placeholder={t("commun.form.placeholder.placeholder3")}
            value={state.pays}
            onChange={(e) =>
              setState({ ...state, [e.target.name]: e.target.value })
            }
          />
          <label className="mt-2">{t("commun.form.label.intitule10")}</label>
          <Form.Control
            type="text"
            name="lat"
            placeholder={t("commun.form.placeholder.placeholder4")}
            value={state.lat}
            onChange={(e) =>
              setState({ ...state, [e.target.name]: e.target.value })
            }
          />
          <label className="mt-2">{t("commun.form.label.intitule11")}</label>
          <Form.Control
            type="text"
            name="lng"
            placeholder={t("commun.form.placeholder.placeholder5")}
            value={state.lng}
            onChange={(e) =>
              setState({ ...state, [e.target.name]: e.target.value })
            }
          />
          {state.adresse !== "" && (
            <>
              <Button className="border mt-1" onClick={(e) => preremplirGPS(e)}>
                {t(
                  "admin.PageAdminLocalisations.modalCreateEditButtonHelp"
                )}
              </Button>
              <div className="text-danger fst-italic ms-2">{errorGPS}</div>
            </>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id
            ? t("commun.form.button.modifier")
            : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
